import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  d: "M6.26 9L12 13.47 17.74 9 12 4.53z",
  opacity: ".3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M19.37 12.8l-7.38 5.74-7.37-5.73L3 14.07l9 7 9-7zM12 2L3 9l1.63 1.27L12 16l7.36-5.73L21 9l-9-7zm0 11.47L6.26 9 12 4.53 17.74 9 12 13.47z"
})), 'LayersTwoTone');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/LayersTwoTone.js
// module id = 4439
// module chunks = 2